import { lazy } from "react"
export const Dashboard = lazy(() => import("./home/Dashboard"));
export const Employee = lazy(() => import("./employee/Employee"));
export const DepartureEmployee = lazy(() => import("./employee/departure/DepartureEmployee"));
export const OnboardEmployee = lazy(() => import("./employee/onboardEmployee/OnboardEmployee"))
export const Overtime = lazy(() => import("./overtime/Overtime"))
export const Attendance= lazy(()=> import("./attendance/Attendance"))
export const AddEditOvertime = lazy(() => import("./overtime/overtimePage/AddEditOvertime"))
export const ApprovedDeclinedOvertime = lazy(() => import("./overtime/overtimePage/ApprovedDeclinedOvertime"))
export const Contract = lazy(() => import("./contract/Contract"));
export const ContractInfo = lazy(() => import("./contract/newContarct/ContractInfo"));
export const Resources = lazy(() => import("./resources/Resources"));
export const AllocatedResources = lazy(() => import("./resources/allocatedResources/AllocatedResources"));
export * from './leaves'
export * from "./accountSettings"
export * from './payroll'
export * from "./reports"
export * from "./settings"

// store
export * from "./employee/store"
export * from "./contract/store"
export * from "./overtime/store"
export * from "./leaves/store"
export * from "./payroll/store/"
export * from "./payroll/store/SalarySlice"
export { default as SalaryReducer } from "./payroll/store/SalarySlice"
export * from "./home/store"
export * from "./reports/store"
export * from "./accountSettings/store"
export * from "./resources/store"
export * from "./attendance/store"
